export default "__VITE_ASSET__v2IBgL8J__"